import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Util } from "../../../utils/util";
import { ReceiptsService } from "../receipts.service";
import { Detail } from "../models/details";
import { Auth } from "../../../autentication/Auth";
import { TransactionType } from "../../extract/extract.model";

@Component({
	selector: "app-transfer-receipt",
	templateUrl: "./transfer-receipt.component.html",
	styleUrls: ["./transfer-receipt.component.styl"],
	encapsulation: ViewEncapsulation.None,
})
export class TransferReceiptComponent implements OnInit {
	source: string;
	receipt: Detail;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private receiptsService: ReceiptsService
	) {}

	ngOnInit(): void {
		this.getReceipt();
	}

	getReceipt() {
		this.receipt = this.receiptsService.getSelectedReceipt();
		if (!this.receipt) {
			this.goBack();
		}
	}

	goBack = () => this.router.navigate(["comprovantes/"]);
	emitNew = () => this.router.navigate(["comprovantes/"]);
	emitPrint = () => window.print();

	getCpfCnpj(cpfCnpj: string) {
		if(!cpfCnpj){
			return;
		}

		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	get transactionType(): string {
		switch (this.receipt.transactionType) {
			case TransactionType.TED_ENVIADO:
			case TransactionType.TED_RECEBIDO:
				return "TED";
			case TransactionType.DOC_ENVIADO:
			case TransactionType.DOC_RECEBIDO:
				return "DOC";
			case TransactionType.TEF_ENVIADO:
			case TransactionType.TEF_RECEBIDO:
				return "TEF";
			default:
				return this.receipt.transactionType;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/transfer-receipt/transfer-receipt.component.ts